export default __webpack_public_path__ + "static/media/Spinner.17da096d.svg";